export enum WidgetType {
  CARD = 'card',
  CARDLESS = 'cardless',
}
